import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(fetchUserSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(loginUserSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(loginUserSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(logoutUserSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(logoutUserSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(authSaga);

import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { AuthService, GridsService, PopupsService } from '@services';
import { ConstantsUtil } from '@utils';
import { Popups } from '@enums';
import { FETCH_USER_REQUEST, LOGIN_USER_REQUEST, LOGOUT_USER_REQUEST } from './auth.action-types';
import { actions } from './auth.actions';

function fetchUserSagaWorker(action) {
  var _yield$call, data;

  return _regeneratorRuntime.wrap(function fetchUserSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(AuthService.apiCurrentUser);

        case 3:
          _yield$call = _context.sent;
          data = _yield$call.data;
          _context.next = 7;
          return put(actions.fetchUserSuccess({
            user: data
          }));

        case 7:
          _context.next = 9;
          return put({
            type: "".concat(FETCH_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: data
          });

        case 9:
          _context.next = 18;
          break;

        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          _context.next = 15;
          return put(actions.fetchUserFailure({
            error: _context.t0
          }));

        case 15:
          _context.next = 17;
          return put({
            type: "".concat(FETCH_USER_REQUEST, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            payload: _context.t0
          });

        case 17:
          AuthService.removeTokenLocalStorage();

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 11]]);
}

function fetchUserSagaWatcher() {
  return _regeneratorRuntime.wrap(function fetchUserSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(FETCH_USER_REQUEST, fetchUserSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function loginUserSagaWorker(action) {
  var values, _yield$call2, data, _yield$call3, user, error;

  return _regeneratorRuntime.wrap(function loginUserSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          values = action.payload.values;
          _context3.next = 4;
          return call(AuthService.apiLogin, values);

        case 4:
          _yield$call2 = _context3.sent;
          data = _yield$call2.data;
          _context3.next = 8;
          return call(AuthService.apiCurrentUser);

        case 8:
          _yield$call3 = _context3.sent;
          user = _yield$call3.data;
          _context3.next = 12;
          return put(actions.loginUserSuccess(_objectSpread(_objectSpread({}, data), {}, {
            user: user
          })));

        case 12:
          _context3.next = 26;
          break;

        case 14:
          _context3.prev = 14;
          _context3.t0 = _context3["catch"](0);
          error = _context3.t0;
          _context3.next = 19;
          return put(actions.loginUserFailure({
            error: error
          }));

        case 19:
          _context3.prev = 19;
          _context3.next = 22;
          return call(PopupsService.open, Popups.Error, {
            header: error.name,
            body: error.message
          });

        case 22:
          _context3.next = 26;
          break;

        case 24:
          _context3.prev = 24;
          _context3.t1 = _context3["catch"](19);

        case 26:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 14], [19, 24]]);
}

function loginUserSagaWatcher() {
  return _regeneratorRuntime.wrap(function loginUserSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(LOGIN_USER_REQUEST, loginUserSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function logoutUserSagaWorker() {
  return _regeneratorRuntime.wrap(function logoutUserSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return call(AuthService.apiLogout);

        case 3:
          _context5.next = 5;
          return put(actions.logoutUserSuccess());

        case 5:
          _context5.next = 7;
          return call(AuthService.removeTokenLocalStorage);

        case 7:
          _context5.next = 9;
          return call(GridsService.closeAll);

        case 9:
          _context5.next = 11;
          return call(AuthService.goToAuthRoute);

        case 11:
          _context5.next = 17;
          break;

        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 17;
          return put(actions.logoutUserFailure({
            error: _context5.t0
          }));

        case 17:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[0, 13]]);
}

function logoutUserSagaWatcher() {
  return _regeneratorRuntime.wrap(function logoutUserSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(LOGOUT_USER_REQUEST, logoutUserSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

export default function authSaga() {
  return _regeneratorRuntime.wrap(function authSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return all([fork(fetchUserSagaWatcher), fork(loginUserSagaWatcher), fork(logoutUserSagaWatcher)]);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}